<div class="accidentes">
  <form (ngSubmit)="onSubmitClaim()">
    <!-- Información -->
    <div class="info-container card">
      <h5 class="title">Formulario de reclamación</h5>
      <div class="info">
        <!------------------- Column 1 ------------------------->
        <!-- Fecha Accidente-->
        <div class="input-box fecha-accidente">
          <label for="fecha-accidente">Fecha del accidente</label>
          <input
            (change)="getPolicies()"
            [(ngModel)]="lossDate"
            name="fecha-accidente"
            type="date"
            id="fecha-accidente"
            [max]="today"
            class="input-field date-input"
            placeholder=""
          />
        </div>

        <!-- Identificacion -->
        <!-- Elementos deshabilitados al buscar poliza direactamente por su número -->
        <div class="identificacion-container">
          <!-- Tipo de identificación -->
          <div class="input-box tipo-identificacion">
            <label for="tipo-identificacion">Tipo de identificación</label>
            <select
              [ngClass]="{ disabled: !!formattedpolicy }"
              [disabled]="!!formattedpolicy"
              (change)="getPolicies('tipo-identificacion')"
              [(ngModel)]="documentType"
              name="tipo-identificacion"
              id="tipo-identificacion"
              class="input-field"
            >
              <option disabled selected value="">
                Seleccionar tipo de documento...
              </option>
              <option
                *ngFor="let document of documents | keyvalue"
                [value]="document.value.code"
              >
                {{ document.value.description }}
              </option>
            </select>
          </div>
          <!-- Número de identificación -->
          <!-- Elemento deshabilitado hasta no seleccionar tipo documento -->
          <div class="input-box identificacion">
            <label for="identificacion">Núm. de identificación</label>
            <input
              [ngClass]="{
                disabled: !lossDate || !!formattedpolicy
              }"
              [disabled]="!lossDate || !!formattedpolicy"
              (change)="getPolicies()"
              (input)="documentType !== documents['pasaporte'].code.toString() ? onlyNumbers($event) : ''"
              (keypress)="documentType !== documents['pasaporte'].code.toString() ? onlyNumbers($event) : ''"
              [disabled]="!documentType"
              [(ngModel)]="documentNumber"
              type="text"
              name="identificacion"
              id="identificacion"
              class="input-field"
              placeholder="Escribir núm. de identificación..."
            />
          </div>
        </div>

        <!-- Nombre asegurado -->
        <!-- Elemento siempre deshabilitado por llenado automático -->
        <div class="input-box nombre-asegurado">
          <label for="nombre-asegurado">Nombre del asegurado</label>
          <input
            disabled
            [value]="insuredName"
            type="text"
            name="nombre-asegurado"
            id="nombre-asegurado"
            class="input-field disabled"
            placeholder="Nombre de asegurado..."
          />
        </div>

        <!-- Nombre Conductor -->
        <div class="input-box nombre-conductor">
          <label for="nombre-conductor">Nombre del conductor</label>
          <input
            type="text"
            [(ngModel)]="driverName"
            name="nombre-conductor"
            id="nombre-conductor"
            class="input-field"
            placeholder="Escribir nombre de conductor..."
          />
        </div>

        <!------------------- Column 2 ------------------------->
        <!-- POLIZAS -->
        @if(!policies.length || !!formattedpolicy){
        <!--Elemento deshabilitado hasta seleccionar fecha de siniestro -->
        <!--Elemento desparece al buscar polizas por tipo de documento -->
        <div class="input-box poliza">
          <label for="formattedpolicy">Núm. de póliza</label>
          <input
            #txt
            (change)="getPolicies('policy')"
            (input)="onlyNumbers($event)"
            (keypress)="onlyNumbers($event)"
            [ngClass]="{ disabled: !lossDate  }"
            [disabled]="!lossDate"
            [(ngModel)]="formattedpolicy"
            name="formattedpolicy"
            type="text"
            id="formattedpolicy"
            class="input-field"
            placeholder="Escribir número de póliza..."
          />
        </div>
        }@else{
        <!--Elemento invisible hasta buscar polizas por tipo de documento -->
        <div class="input-box poliza">
          <label for="poliza">Núm. de póliza</label>
          <select
            (change)="getVehicles()"
            [ngClass]="{ disabled: !policies.length }"
            [disabled]="!policies.length"
            [(ngModel)]="policy"
            name="poliza"
            id="poliza"
            class="input-field"
          >
            <option disabled selected value="">Seleccionar poliza...</option>
            <option
              *ngFor="let policy of policies"
              [value]="policy.policyNumber"
            >
              {{ policy.policyNumber }}
            </option>
          </select>
        </div>
        }
        <!-- Referencia Vehiculo -->
        <!--Elemento deshabilitado hasta seleccionar póliza -->
        <div class="input-box ref-vehiculo">
          <label for="ref-vehiculo">Núm. de unidad de vehículo</label>
          <input
            list="vehicles-list"
            (change)="getCoverages()"
            [ngClass]="{ disabled: !vehicles.length }"
            [disabled]="!vehicles.length"
            [(ngModel)]="vehicleInfo"
            name="ref-vehiculo"
            id="ref-vehiculo"
            class="input-field"
            placeholder="Seleccionar vehículo..."
            type="text"
          />

          <datalist id="vehicles-list">
            <option
              *ngFor="let vehicle of vehicles"
              [value]="vehicle.makeModelDescription +
                '-' +
                vehicle.registrationNumber +
                '-' +
                vehicle.vinNumber"
            >
              {{
                vehicle.makeModelDescription +
                '-' +
                vehicle.registrationNumber +
                '-' +
                vehicle.vinNumber
              }}
            </option>
          </datalist>
        </div>

        <!-- Siniestro -->
        <!--Elemento deshabilitado hasta seleccionar vehículo -->
        <div class="input-box siniestro">
          <label for="siniestro">Tipo de siniestro</label>
          <select
            (change)="getFiles()"
            [(ngModel)]="coverageCode"
            [ngClass]="{ disabled: !coverages.length }"
            [disabled]="!coverages.length"
            name="siniestro"
            id="siniestro"
            class="input-field"
          >
            <option disabled selected value="">
              Seleccionar tipo de siniestro...
            </option>
            <option
              *ngFor="let coverage of coverages"
              [value]="coverage.coverageCode"
            >
              {{ coverage.shortDescription }}
            </option>
          </select>
        </div>

        <!------------------- Column 3 ------------------------->
        <!-- Lesiones -->
        <div class="input-box lesiones">
          <label for="lesiones">¿Hubo lesiones?</label>
          <div>
            <button
              type="button"
              class="button yes-button"
              id="lesiones"
              (click)="setHasInjured(true)"
              [ngClass]="{ active: hasInjured }"
            >
              Sí
            </button>
            <button
              type="button"
              class="button no-button"
              id="lesiones"
              (click)="setHasInjured(false)"
              [ngClass]="{ active: !hasInjured }"
            >
              No
            </button>
          </div>
        </div>

        <!-- Inmovil -->
        <div class="input-box inmovil">
          <label for="inmovil">¿Vehículo inmóvil?</label>
          <div>
            <button
              type="button"
              class="button yes-button"
              id="inmovil"
              (click)="setStationaryVehicle(true)"
              [ngClass]="{ active: stationaryVehicle }"
            >
              Sí
            </button>
            <button
              type="button"
              class="button no-button"
              id="inmovil"
              (click)="setStationaryVehicle(false)"
              [ngClass]="{ active: !stationaryVehicle }"
            >
              No
            </button>
          </div>
        </div>

        <!-- Detalles -->
        <div class="input-box detalles-siniestro">
          <label for="detalles-siniestro">Detalles de siniestro</label>
          <textarea
            rows="5"
            [(ngModel)]="eventDescription"
            type="text"
            name="detalles-siniestro"
            id="detalles-siniestro"
            class="input-field"
            placeholder=""
          ></textarea>
        </div>
      </div>
    </div>

    <!---------------------- Documentos requeridos ---------------------->
    @if (!!filesToUpload.length) {
    <div class="files card mt-3">
      <h5 class="title">Documentos requeridos</h5>
      <div class="uploads-container">
        <div
          *ngFor="let fileType of filesToUpload"
          class="input-box file-to-upload mt-4"
        >
          <label for="file">{{ fileType.description }}</label>
          <input
            (change)="onFileSelected($event, fileType.code, fileType.type)"
            id="file-{{ fileType.code }}"
            name="file"
            type="file"
            class="input-field file"
            placeholder=""
          />
          @if (!!fileType.message) {
          <small class="message">({{ fileType.message }})</small>
          }
        </div>
      </div>
    </div>
    }

    <!----------------------- Inspección -------------------------------->
    <div class="inspection card">
      <!-- Row 1 -->
      <h5 class="title">Método de inspección</h5>

      <div class="inspection-form">
        <p class="inspection pt-3">¿Cómo deseas la inspección?</p>
        <div class="input-box tipo-inspection">
          <select
            [ngClass]="{ disabled: stationaryVehicle || !selectedVehicle || selectedVehicle.isBasicCoverage}"
            [disabled]="stationaryVehicle || !selectedVehicle || selectedVehicle.isBasicCoverage"
            [(ngModel)]="inspectionType"
            name="tipo-inspection"
            name="tipo-inspection"
            class="input-field"
            (change)="setInspectionType()"
          >
            <option selected disabled value="">
              Seleccionar tipo de inspección...
            </option>
            <option
              *ngFor="let record of filteredInspectionTypes"
              [value]="record.inspectionType"
            >
              {{ record.description }}
            </option>
          </select>
        </div>
        <div class="input-box fecha-inspection">
          <input
            [ngClass]="{ disabled: isInspectionDateDisabled()}"
            [disabled]="isInspectionDateDisabled()"
            [(ngModel)]="inspectionDate"
            (change)="getInspectionAvailableTime()"
            type="date"
            [min]="today"
            name="fecha-inspection"
            class="input-field date-input"
            placeholder=""
          />
        </div>
        <div class="input-box hora-disponible">
          <select
            [ngClass]="{ disabled: !availabilityTime.length }"
            [disabled]="!availabilityTime.length"
            [(ngModel)]="inspectionTime"
            name="hora-disponible"
            id="hora-disponible"
            class="input-field"
          >
            <option disabled selected value="">Seleccionar horario...</option>
            <option
              *ngFor="let record of availabilityTime"
              [value]="record.time"
            >
              {{ record.formattedTime }}
            </option>
          </select>
        </div>
        <!-- Row 2 -->
        <div class="input-box celular">
          <label for="celular">Celular</label>
          <input
            (input)="onlyNumbers($event)"
            (keypress)="onlyNumbers($event)"
            type="text"
            [(ngModel)]="phoneNumber"
            name="celular"
            id="celular"
            class="input-field"
            placeholder="Ingrese su número de contacto..."
            [maxlength]="10"
          />
        </div>
        <div class="input-box correo">
          <label for="correo">Correo electrónico</label>
          <input
            type="text"
            [(ngModel)]="emailAddress"
            name="correo"
            id="correo"
            class="input-field"
            placeholder="Ingrese su correo..."
          />
        </div>
        <button type="button" class="btn-s-new limpiar" (click)="clearForm()">
          Limpiar
        </button>
        <button class="btn-m-new enviar" type="submit">Enviar</button>
      </div>
    </div>
  </form>
</div>

<!-- Notificacion -->

<app-notification
  [show]="showNotification"
  [type]="notificationType"
  [title]="notificationTitle"
  [message]="notificationMessage"
></app-notification>

<!-- Request Notifiactión -->
@if(requestNotification){
<div class="request-notification-modal">
  <div class="modal-container">
    <img [src]="requestNotifcationIcon" alt="" />
    <h3 class="mb-4">
      <strong>{{ requestNotifcationTitle }}</strong>
    </h3>
    <p>{{ requestNotifcationMessage }}</p>
    <button (click)="showRequestNotificationModal()" class="btn-m-new mt-3">
      Cerrar
    </button>
  </div>
</div>
}
